import ReactHtmlParser from 'react-html-parser';

//export const lang = document.querySelector('meta[name="data-language"]') ? document.querySelector('meta[name="data-language"]').content === 'en' ? 'en' : 'fr' : 'en';
export function getLang() {
    return document.querySelector('meta[name="data-language"]') ? document.querySelector('meta[name="data-language"]').content === 'en' ? 'en' : 'fr' : 'en';
}

//export const province = document.querySelector('meta[name="data-region"]') ? document.querySelector('meta[name="data-region"]').content : 'on';
export function getProvince() {
    // This is used in the case of retailer
    if ((window.location.href.includes("retailer") || window.location.href.includes("localhost")) 
        && sessionStorage.getItem('bnp_dealerVars')) {
        const dealerVars = JSON.parse(sessionStorage.getItem('bnp_dealerVars'));

        if(dealerVars && dealerVars.dealerProvinceCode)
            return dealerVars.dealerProvinceCode;
    }

    // Fallback from the cms
    return document.querySelector('meta[name="data-region"]') ? document.querySelector('meta[name="data-region"]').content : 'on';    
}

// DEPRECATED, TCCI return it in the API response
/*export function getPPSA(term) {
    const ppsaTable = JSON.parse(sessionStorage.getItem('financialObj')).PPSA;

    let ppsa = 0;
    const sortedPpsa = ppsaTable.sort((a, b) => a.term > b.term)
    sortedPpsa.forEach(ppsaItem => {
        if (ppsaItem.term === term)
            ppsa = ppsaItem.rate;
    });

    if (!ppsa) {
        for (const ppsaItem of sortedPpsa) {
            if (ppsaItem.term > term) {
                ppsa = ppsaItem.rate;
                break;
            }
        }
    }

    return ppsa;
}*/

export function setCursorWaiting(isWaiting) {
    if (isWaiting)
        document.querySelector("html").style.cursor = "wait";
    else
        document.querySelector("html").style.cursor = "";
}

export function getLoading(isLoading, t) {
    if (!window.bnp_under_maintenance) {
        return (
            <div className={`loading ${isLoading ? 'visible' : ''}`}>
                <h1>{t("general:loading")}</h1>
            </div>
        )
    } else {
        return (
            <div className={`loading ${isLoading ? 'visible' : ''}`}>
                <h5>{ReactHtmlParser(t("general:retryMessage"))}</h5>
            </div>
        )
    }
}

export function getMazdaFeesAndLeviesDetailTitle(title, t) {
    switch (title) {
        case "Administration Fee":
            return t("general:admin_service_fees"); //"Administration Fee"; 
        case "Lease Service Fees":
            return t("general:lease_service_fees"); //"Lease Dealer Service Fee";
        case "A/C Tax":
            return t("general:ac_tax"); //"Air Conditioning Tax";
        case "OMVIC":
            return t("general:omvic"); //"OMVIC Fee";
        case "AMVIC":
            return t("general:amvic"); //"AMVIC Fee";
        case "Oil":
            return t("general:oil"); //"Oil Filter Fee";
        case "Tire Shewardship Fee":
        case "Tire":
            return t("general:tire"); //"Tire Stewardship Fee";
        case "PDE":
            return t("general:pde"); //"Pre Delivery Inspection Fee";
        case "Federal Excise Tax":
            return t("general:federal_excise_tax");
        case "Freight":
            return t("general:freight");
        case "ppsa":
            return t("general:ppsa");

        default:
            return title;
    }
}

export function getParams(str) {
    var queryString = str || window.location.href || '';
    var keyValPairs = [];
    var params = {};
    queryString = queryString.replace(/.*?\?/, "");

    if (queryString.length) {
        keyValPairs = queryString.split('&');
        for (let pairNum in keyValPairs) {
            var key = keyValPairs[pairNum].split('=')[0];
            if (!key.length) continue;
            if (typeof params[key] === 'undefined')
                params[key] = [];
            params[key].push(keyValPairs[pairNum].split('=')[1]);
        }
    }
    return params;
}

/*
 * Return the API Base URL according to which environement we are on.
 */
export function getApiBaseUrl() {
    if (window.location.host.indexOf("localhost") !== -1)
        return process.env.REACT_APP_API_PATH_DEV;
    else if (window.location.host.indexOf("dev") !== -1)
        return process.env.REACT_APP_API_PATH_DEV;
    else if (window.location.host.indexOf("mzca02mstrs16bzs001.dxcloud.episerver.net") !== -1)
        return process.env.REACT_APP_API_PATH_PREPROD;
    else if (window.location.host.indexOf("preprod") !== -1)
        return process.env.REACT_APP_API_PATH_PREPROD;
    else if (window.location.host.indexOf("preprod2") !== -1)
        return process.env.REACT_APP_API_PATH_PREPROD2;
    else
        return process.env.REACT_APP_API_PATH_PROD;
}

export function getBaseUrl() {
    if (window.location.host.indexOf("localhost") !== -1)
        return "https://preprod.mazda.ca";
    else if (window.location.host.indexOf("mzca02mstrs16bzs001.dxcloud.episerver.net") !== -1)
        return "https://preprod.mazda.ca";
    else
        return window.location.protocol + '//' + window.location.host;
}

export function get360Data(visual, exterior = null, interior = null) {
    //console.log(visual, exterior, interior);

    if (visual) {
        const extCode = exterior ? exterior.code : visual.interiors[0].default_exterior.code;
        const intCode = interior ? interior.code : visual.interiors[0].code;
        if (!visual.exteriors[extCode]) {
            return {
                'imagePlaceHolder': getBaseUrl() + process.env.REACT_APP_IMAGE_PLACEHOLDER_PATH
            };
        }

        const baseAssetPath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
        const { file_path, end_index: imageAmount, filename_prefix } = visual.exteriors[extCode][360];
        const imageName = interior && interior.include_in_360 ? `${filename_prefix.replace(" ", "-")}${intCode}-{index}.png` : `${filename_prefix.replace(" ", "-")}{index}.png`;
        const imagePath = baseAssetPath + file_path.replace(" ", "-");
        const { filename } = visual.interiors.find((currInt) => currInt.code === intCode);

        //const realFileName = interior.include_in_360 ? filename.replace(".png","") + intCode + ".png" : filename;
        //console.log(realFileName);
        const imagePathInterior = baseAssetPath + filename;

        return {
            imagePathInterior,
            imagePath,
            imageAmount,
            imageName,
        };
    } else {
        return {
            'imagePlaceHolder': getBaseUrl() + process.env.REACT_APP_IMAGE_PLACEHOLDER_PATH
        };
    }

}

export function getUrlParamsObject() {
    if (window.location.search.length)
        return decodeURI(window.location.search)
            .replace('?', '')
            .split('&')
            .map(param => param.split('='))
            .reduce((values, [key, value]) => {
                values[key] = value
                return values
            }, {});

    return {};
}

export function getUrlParams(paramsObject) {
    return Object.keys(paramsObject)
        .map(key => `${key}=${paramsObject[key]}`)
        .join('&');
}

export function getThumbnail(visual, model) {
    return;
}

export function formatPrice(amount, noRounding) {
    if (amount === undefined || isNaN(amount))
        return '';

    const fractions = noRounding ? 2 : 0;

    const locale = getLang() === 'fr' ? 'fr-CA' : 'en-CA';
    return Number(amount).toLocaleString(locale, { style: 'currency', currency: 'CAD', minimumFractionDigits: fractions, maximumFractionDigits: fractions })
}
export const convertKM = (distance) => {
    const locale = getLang() === 'fr' ? 'fr-CA' : 'en-CA';
    const kmFormat = getLang() === 'fr' ? ' km' : 'KM';
    return Number(distance).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + kmFormat;
}
export const convertNum = (num, fractions) => {
    fractions = fractions === undefined ? 0 : fractions;
    const locale = getLang() === 'fr' ? 'fr-CA' : 'en-CA';
    return Number(num).toLocaleString(locale, { minimumFractionDigits: fractions, maximumFractionDigits: fractions });
}

export function getBareWeekly(amount, term) {
    const numberYears = term / 12;
    const numberWeeks = numberYears * 52;
    const result = formatPrice(amount / numberWeeks);

    if (result === '$NaN')
        return "";
    else
        return result;
}

export function getFinanceWeekly(amount, rate, term) {
    const testRate = rate / 100;
    const result = formatPrice((amount * (testRate / 52)) / (1 - Math.pow((1 + (testRate / 52)), -((term / 12) * (52)))));

    //console.log('getFinanceWeekly', amount, rate, term, result);

    if (result === '$NaN')
        return "";
    else
        return result;
}

export function getLeaseBiWeeklyFromOptions(amount, rate, term) {
    let result;

    result = formatPrice(Math.ceil(amount / term * 12 / 26));

    if (result === '$NaN')
        return "";
    else
        return result;
}

export function getLeaseBiWeeklyFromMsrp(amount, rate, term) {
    let result;

    const financialObj = JSON.parse(sessionStorage.getItem('financialObj'));
    
    const subtotal = amount + financialObj.adminServiceFees;
    const residual = financialObj.residual.find(element => element.term === term).rate;
    const kilometersLeaseValue = 0;
    const endValueLease = (subtotal) * ((residual + kilometersLeaseValue) / 100);

    result = formatPrice(Math.ceil(subtotal - endValueLease) / (term / 12 * 26));

    if (result === '$NaN')
        return "";
    else
        return result;
}

export function goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}


export function getIncentiveDisplayName(incentive) {
    switch (incentive) {
        case "loyalty":
            return getLang() === 'fr' ? "Programme renouvellement de fidélité Mazda" : "Mazda Owner Loyalty Program";
        case "military":
            return getLang() === 'fr' ? "Programme Mazda pour militaires" : "Mazda Military Program";
        case "grad_award":
            return getLang() === 'fr' ? "Programme de diplômés Mazda" : "Mazda Graduate Program Award";
        case "first_time_owner":
            return getLang() === 'fr' ? "Programme Mazda pour premier propriétaire" : "Mazda First Owner Program";            
        default:
            return incentive.type;
    }
  }

export function getDisplayableProvinceName() {
    switch(getProvince().toLowerCase()) {
        case 'on': 
            return getLang() === 'en' ? "Ontario" : "de l'Ontario"
        case 'qc':
            return getLang() === 'en' ? 'Quebec' : "du Québec"
        case 'ab':
            return getLang() === 'en' ? 'Alberta' : "de l'Alberta"
        case 'bc':
            return getLang() === 'en' ? 'British Columbia' : "de la Colombie Britanique"
        case 'mb':
            return getLang() === 'en' ? 'Manitoba' : "du Manitoba"
        case 'nb':
            return getLang() === 'en' ? 'New Brunswick' : "du Nouveau-Brunswick"
        case 'nl':
            return getLang() === 'en' ? 'Newfoundland' : 'de Terre-Neuve'
        case 'nt':
            return getLang() === 'en' ? 'North-West Territories' : 'du Territoires du nord-ouest'
        case 'ns':
            return getLang() === 'en' ? 'Nova Scotia' : 'de la Nouvelle-Écosse'
        case 'nu':
            return getLang() === 'en' ? 'Nunavut' : "du Nanavut"
        case 'pe':
            return getLang() === 'en' ? 'Prince Edward Island' : "de l'Île-du-Prince-Édouard"
        case 'sk':
            return getLang() === 'en' ? 'Saskatchewan' : "du Saskatchewan"
        case 'yt':
            return getLang() === 'en' ? 'Yukon' : 'du Yukon'
        default:
            return '';
    }
}

export function buildLegalContent(legalContentObject, legalIncentiveObject) {
    let legalContent = '';
    if (legalContentObject) {
        legalContentObject.map(item => {
            legalContent += item.copy
        });
    }

    // Append incentive legal
    if(legalIncentiveObject) {
        legalIncentiveObject.map(item => {
            legalContent += item.copy
        });
    }

    return legalContent;
}

export function hideCmsHiddenBlock() {
    let shownBlocks = document.querySelectorAll('#Awards > .visually-shown');

    if (shownBlocks) {
        shownBlocks.forEach(function (e) {
            e.classList.remove('visually-shown');
            e.classList.add('visually-hidden');
        });
    }

    hideCmsFooterHiddenBlock();
}

export function showCmsHiddenBlock(carline) {
    let hiddenBlocks = document.querySelectorAll('#BNP_AWARDS > .visually-hidden')//('#Awards > .'+carline+'.visually-hidden');

    if (hiddenBlocks) {
        hiddenBlocks.forEach(function (e) {
            e.classList.remove('visually-hidden');
            e.classList.add('visually-shown');
        });
    }
}

export function hideCmsFooterHiddenBlock() {
    let hiddenBlocks = document.querySelectorAll('.mz-footer.mz-footer--container');

    if (hiddenBlocks) {
        hiddenBlocks.forEach(function (e) {
            e.classList.remove('visually-shown');
            e.classList.add('visually-hidden');
        });
    }
}

export function showCmsFooterHiddenBlock() {
    let hiddenBlocks = document.querySelectorAll('.mz-footer.mz-footer--container');

    if (hiddenBlocks) {
        hiddenBlocks.forEach(function (e) {
            e.classList.remove('visually-hidden');
            e.classList.add('visually-shown');
        });
    }
}

export function getCmsAwardsBlockFromCMS(year, carline) {
    if(!year || !carline) {
        return "";
    }

    let hiddenBlocks = document.querySelector(`#Awards > .${carline}-${year}.visually-hidden`);//('#Awards > .'+carline+'.visually-hidden');

    if (hiddenBlocks) {
        let text = hiddenBlocks.outerHTML.replace('visually-hidden', '');
        
        // Regular expression to replace src with data-src // fix for the hotlink that doesnt load the lazy load
        const regex = /<img\s+src="([^"]+)"\s+data-src="([^"]+)"([^>]*)>/g;

        // Replace src with data-src
        const toReturn = text.replace(regex, '<img src="$2" data-src="$2"$3>');
        //console.log(toReturn);

        return toReturn;
    }

    return "";
}

export function customRound(value, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.ceil(value * factor) / factor;
}

export function updateLanguageLink() {
    const languageLink = document.getElementById('region-language-link');

    // Update the language link (From any submit return)
    if (window.location.hash && languageLink) {
        const newLanguage = languageLink.text;

        const langCodePattern = /lang_code=[^&]*/;

        // Remove the old hash
        if (languageLink.href.indexOf('#') !== -1) {
            const hashIndexPosition = languageLink.href.indexOf('#');

            languageLink.href = languageLink.href.substring(0, hashIndexPosition);
        }

        // Replace the lang_code parameter
        let newHash = window.location.hash.replace(langCodePattern, `lang_code=${newLanguage}`);
        languageLink.href = languageLink.href + newHash;
            
        //languageLink.href = languageLink.href.replace(langCodePattern, `lang_code=${newLanguage}`);
    }
}

